import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ConservationProgressCard = ({ project }) => {
  return (
    <div className="bg-card rounded-lg p-5 shadow-conservation hover:shadow-conservation-lg animation-organic">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h4 className="text-base font-semibold text-foreground mb-1">{project?.title}</h4>
          <p className="text-xs text-muted-foreground">{project?.location}</p>
        </div>
        <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${
          project?.status === 'Completed' ? 'bg-success/20' :
          project?.status === 'In Progress'? 'bg-warning/20' : 'bg-info/20'
        }`}>
          <Icon 
            name={project?.status === 'Completed' ? 'CheckCircle' : 'Activity'} 
            size={20}
            color={
              project?.status === 'Completed' ? 'var(--color-success)' :
              project?.status === 'In Progress' ? 'var(--color-warning)' :
              'var(--color-info)'
            }
          />
        </div>
      </div>
      {/* Before/After Images */}
      {project?.beforeImage && project?.afterImage && (
        <div className="grid grid-cols-2 gap-2 mb-4">
          <div className="relative">
            <div className="h-24 rounded overflow-hidden">
              <Image
                src={project?.beforeImage}
                alt={project?.beforeImageAlt}
                className="w-full h-full object-cover"
              />
            </div>
            <span className="absolute bottom-1 left-1 bg-black/70 px-2 py-0.5 rounded text-xs text-white">
              Before
            </span>
          </div>
          <div className="relative">
            <div className="h-24 rounded overflow-hidden">
              <Image
                src={project?.afterImage}
                alt={project?.afterImageAlt}
                className="w-full h-full object-cover"
              />
            </div>
            <span className="absolute bottom-1 left-1 bg-black/70 px-2 py-0.5 rounded text-xs text-white">
              After
            </span>
          </div>
        </div>
      )}
      {/* Progress Bar */}
      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs text-muted-foreground">Progress</span>
          <span className="text-xs font-semibold text-foreground">{project?.progress}%</span>
        </div>
        <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
          <div
            className="h-full bg-success animation-organic"
            style={{ width: `${project?.progress}%` }}
          ></div>
        </div>
      </div>
      {/* Impact Metrics */}
      <div className="grid grid-cols-2 gap-3 mb-4">
        {project?.metrics?.map((metric, index) => (
          <div key={index} className="bg-muted p-3 rounded">
            <div className="flex items-center gap-1 mb-1">
              <Icon name={metric?.icon} size={14} color="var(--color-secondary)" />
              <span className="text-xs text-muted-foreground">{metric?.label}</span>
            </div>
            <p className="text-sm font-semibold text-foreground">{metric?.value}</p>
          </div>
        ))}
      </div>
      {/* Status Badge */}
      <div className="flex items-center justify-between">
        <span className={`text-xs px-3 py-1 rounded-full ${
          project?.status === 'Completed' ? 'bg-success/20 text-success' :
          project?.status === 'In Progress'? 'bg-warning/20 text-warning' : 'bg-info/20 text-info'
        }`}>
          {project?.status}
        </span>
        <span className="text-xs text-muted-foreground">{project?.timeline}</span>
      </div>
    </div>
  );
};

export default ConservationProgressCard;